export const modalBoxClassName =
    'bg-giphyBlack border-giphyDarkCharcoal relative flex flex-col rounded-md border border-solid'
export const modalBackgroundClassName =
    'bg-giphyBlack/80 z-modal absolute inset-0 flex animate-[fadeIn_150ms_ease-in-out] items-center justify-center'
